module.exports = __webpack_public_path__ + "img/white-2.d36a4af1.png";